import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import axios from "axios";
import BoxAlertError from "../../LoginComponent/BoxAlert";
import BoxAlert from "../../LoginComponent/BoxAlert";
import Loading from "../../LoadingComponent";

const ResetPassword = () => {
    const { t } = useTranslation();
    const [complete, setComplete] = useState(false);
    const [expire, setExpire] = useState(false);
    const [loading, setLoading] = useState(true); // เริ่มต้นเป็น true เพื่อตรวจสอบ code ก่อน
    let params = useParams();

    const formSchema = Yup.object().shape({
        newPassword: Yup.string().required(t("error_required_password")).min(8, t("error_min_character")),
    });

    const formOptions = { resolver: yupResolver(formSchema) };

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm(formOptions);

    // ใช้ useEffect เพื่อตรวจสอบ reset code เมื่อ component โหลด
    useEffect(() => {
        const checkResetCode = async () => {
            try {
                const { data } = await axios.get(`/api/user/reset/${params.resetPasswordCode}`);
                if (data.status === 400) {
                    setExpire(true);
                }
                setLoading(false);
            } catch (error) {
                console.error(error);
                setExpire(true);
                setLoading(false);
            }
        };

        checkResetCode();
    }, [params.resetPasswordCode]);

    async function onSubmit(data, event) {
        event.preventDefault();
        const newPassword = data.newPassword;
        setLoading(true);

        try {
            const response = await axios.post(`/api/user/reset/${params.resetPasswordCode}`, {
                newPassword: newPassword,
            });

            setLoading(false);

            if (response.data.status === 200) {
                setComplete(true);
            } else if (response.data.status === 400) {
                setExpire(true);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
            setExpire(true);
        }
    }

    return (
        <section className="forget-password section-login-register-template">
            {loading && <Loading />}
            {expire ? (
                <BoxAlertError title="รหัสหมดอายุหรือไม่มีอยู่ในระบบ" type="error" />
            ) : (
                <>
                    <img
                        src="/img/mbog-official-logo.png"
                        alt=""
                        style={{
                            margin: "0 auto 40px",
                            width: "200px",
                            height: "auto",
                            display: "block",
                        }}
                    />
                    {complete ? (
                        <BoxAlert title={t("change_password_success")} />
                    ) : (
                        <div className="box-login-register-template box-register">
                            <div className="wrapper-form">
                                <h2>{t("set_new_password")}</h2>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className={`group-input ${errors.newPassword && "error"}`}>
                                        <label htmlFor="">{t("fill_new_password")}</label>
                                        <input
                                            type="password"
                                            {...register("newPassword", {
                                                required: true,
                                            })}
                                        />
                                        <span className="error">{errors.newPassword?.message}</span>
                                    </div>
                                    <input type="submit" value={t("btn_confirm")} />
                                </form>
                            </div>
                        </div>
                    )}
                </>
            )}
        </section>
    );
};

export default ResetPassword;
